import { createFileRoute } from "@tanstack/react-router";
import { GrunndataIndexDetail } from "@/components/System/GrunndataDetails";

function GrunndataIndexRoute() {
  return <GrunndataIndexDetail />;
}

export const Route = createFileRoute("/_auth/grunndata/")({
  beforeLoad: () => {
    return {
      getTitle: () => "Grunndata",
    };
  },
  component: GrunndataIndexRoute,
});
